  import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";
import { constructQueryString } from "../../Util/HelperFunction";

export const organisationGroupCreateAction = createAsyncThunk(
  "organisationGroup/create",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post("/organisation-group/create", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const organisationGroupListAction = createAsyncThunk(
  "organisationGroup/list",
  async (reqBody, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(`/organisation-group/list?${query}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const organisationGroupDetailsAction = createAsyncThunk(
  "organisationGroup/details",
  async (id, thunkAPI) => {
    try {
      const response = await Api.get(`/organisation-group/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const organisationGroupUpdateAction = createAsyncThunk(
  "organisationGroup/update",
  async ({ id, reqBody }, thunkAPI) => {
    try {
      const response = await Api.put(`/organisation-group/${id}`, reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const organisationGroupDeleteAction = createAsyncThunk(
  "organisationGroup/delete",
  async (id, thunkAPI) => {
    try {
      const response = await Api.delete(`/organisation-group/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const organisationGroupMemberListAction = createAsyncThunk(
  "organisationGroup/memberList",
  async ({ groupId, ...reqBody }, thunkAPI) => {
    try {
      const query = constructQueryString(reqBody);
      const response = await Api.get(
        query
          ? `/organisation-group/${groupId}/member/list?${query}`
          : `/organisation-group/${groupId}/member/list`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const organisationGroupMemberCreateAction = createAsyncThunk(
  "organisationGroup/memberCreate",
  async ({ groupId, reqBody }, thunkAPI) => {
    try {
      const response = await Api.post(
        `/organisation-group/${groupId}/member/add`,
        reqBody,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const organisationGroupMemberDetailsAction = createAsyncThunk(
  "organisationGroup/memberDetails",
  async (memberId, thunkAPI) => {
    try {
      const response = await Api.get(
        `/organisation-group/member/details/${memberId}`,
      );
      console.log("organisation group member detail response", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const organisationGroupMemberUpdateAction = createAsyncThunk(
  "organisationGroup/memberUpdate",
  async ({ memberId, reqBody }, thunkAPI) => {
    try {
      const response = await Api.put(
        `/organisation-group/member/edit/${memberId}`,
        reqBody,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

export const organisationGroupMemberDeleteAction = createAsyncThunk(
  "organisationGroup/memberDelete",
  async (memberId, thunkAPI) => {
    try {
      const response = await Api.delete(
        `/organisation-group/member/delete/${memberId}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  },
);

const apiRoot = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
const apiHost = apiRoot.replace(/\/admin$/i, "");
const toPublicApiUrl = (path) => (apiHost ? `${apiHost}${path}` : path);

export const organisationEmailCheckAction = createAsyncThunk(
  "organisationGroup/emailCheck",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post(toPublicApiUrl("/school/organisation-group/email-check"), reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const organisationSendInviteAction = createAsyncThunk(
  "organisationGroup/sendInvite",
  async ({ groupId, ...payload }, thunkAPI) => {
    try {
      const response = await Api.post(
        toPublicApiUrl(`/school/organisation-group/${groupId}/send-invite`),
        payload
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);
